export enum CurrencyCode {
    SWEEPS = 'XSD',
    GOLD_COINS = 'XGC',
}
